export default "__VITE_ASSET__DK2Yk42N__"